module.exports = __webpack_public_path__ + "static/media/book.dd3f7606.png";